import React from 'react';
import {Card} from "./styledComponents";
import Summary from "./components/Summary";
import Countdown, {zeroPad} from 'react-countdown-now';

const qbAPI = process.env.REACT_APP_QB;



class QuickBook extends React.Component {


    state = {
        data: false,
        isLoading: true,
    };

    componentDidMount() {

        const {match} = this.props;
        const bookingInfoId = match.params.bookingInfoId;

        this.fetchData(bookingInfoId);

    }

    fetchData = (bookingInfoId) => {
       return fetch(qbAPI + bookingInfoId)
            .then(response => response.json())
            .then(data => this.setState({ data, isLoading: false }))
            .catch(e => console.log(e));
    };

    setBookingComplete = () => {
        alert('hej');
    };

    // Random component
    CompletedCountDown = () => {

        const {match} = this.props;
        const bookingInfoId = match.params.bookingInfoId;

        this.fetchData(bookingInfoId);

        return <span>You are good to go!</span>;
    }

// Renderer callback with condition
    countDownRender = ({ hours, minutes, seconds, completed }) => {

        if (completed) {
            // Render a completed state
            return <this.CompletedCountDown />;
        } else {
            // Render a countdown
            return <span> {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}</span>;
        }
    };



    render() {
        const { data, isLoading } = this.state;
        if (isLoading) {
            return ('Loading');
        }
        if (data.notValid) {
            return ('Expired');
        }
        return (
            <React.Fragment>
                <Card
                    title={'Quick Book'}>
                    Tid kvar att komplettera bokningen:
                    <Countdown date={new Date(data.qbValidUntil)}
                               renderer={this.countDownRender}>
                    </Countdown>
                </Card>
                <br />

                <Summary
                hashId={data.bookingData[0].id}
                lang={data.lang.summary}
                productSettings={data.resources[0].products ? data.resources[0].products.settings : data.resources[1].products.settings}
                voucher={data.voucher}
                inputFields={data.inputFields}
                bookingData={data.bookingData}
                bIKey={data.bIKey}
                setBookingComplete={this.setBookingComplete}
            />
            </React.Fragment>
        )
    }

}

export default QuickBook;



// WEBPACK FOOTER //
// ./src/quickBook.js